const ITEMS = [
  "Everyday things, made clever",
  "Packs flat",
  "No manual needed",
  "Travels well",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-ember/70 bg-ember py-5"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center text-xs uppercase tracking-[0.3em] text-ink"
              >
                <span className="px-8">{item}</span>
                <span className="text-bone">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
